import authService from "@/api/authentication/auth.service";
import moment from "moment";
import UserService from '@/api/rest-administrative/user.service';
import departmentService from "@/api/rest-administrative/department.service";
import router from "@/router";

const state = {
  loggedIn: false,
  token: undefined,
  currentUser: undefined,
  userDetails: undefined
};

const mutations = {
  setUserAuthenticated(state, data) {
    state.loggedIn = true;
    state.token = data;
  },
  setLoginFailure(state) {
    state.loggedIn = false;
    state.token = undefined;
    state.currentUser = undefined;
  },
  cleanUserAuthenticated(state) {
    state.loggedIn = false;
    state.token = undefined;
  },
  setCurrentUser(state, data) {
    state.currentUser = data;
  },
  cleanCurrentUser(state) {
    state.currentUser = undefined;
  },
  setUserDetails(state, data) {
    state.userDetails = data;
  }
};

const actions = {

  async signIn({ commit }, data) {
    const { email, password } = data;

    try {
      const auth = await authService.login(email, password);
      const userInfo = await UserService.getCurrentUserinfo();
      if (userInfo.status == 299) {
        router.push("/ResetPassword").catch(() => { });
        let access_token = auth.access_token;
        commit("setUserAuthenticated", { access_token });
      } else {
        let access_token = auth.access_token;
        commit("setUserAuthenticated", { access_token });
        let profile = await authService.profile(access_token);
        const { roles } = profile.attributes;
        profile.attributes.roles = roles ?? '';
        profile.attributes.expires_in = auth.expires_in
        profile.attributes.timestamp = moment().format('YYYY-MM-DD HH:mm:ss')
        const department = await departmentService.getDepartmentByIds(userInfo.data.departmentId);
        let abrv = userInfo.data.name.split(" ")
        const name = []
        name.push(abrv[0])
        abrv.splice(0, 1)
        abrv.map((e) => {
          if (e.length > 2) {
            name.push(e[0] + ".")
          }
        })
        const userDetails = {
          name: name.join(' '),
          departmentName: department.data.name
        }
        commit("setCurrentUser", profile);
        commit("setUserDetails", userDetails);
        router.push("/Monitoring").catch(() => { });
      }
    } catch (error) {
      commit("setCurrentUser", undefined);
      commit("setLoginFailure");
      switch (error.response.status) {
        case 401: // Unauthorized
          throw {
            name: "Dados incorretos",
            message: "O e-mail/matrícula ou a senha não correspondem!",
          }
        case 500: // Unavailable service
          throw {
            name: "Serviço indisponível",
            message: "Não foi possível realizar o login, tente novamente.",
          }
        case 503: // Unavailable service
          throw {
            name: "Serviço indisponível",
            message: "Não foi possível realizar o login, tente novamente.",
          }
      }
    }
  },
  // eslint-disable-next-line no-unused-vars
  logOut({ commit }) {

    // provisional - force clear all cache databases
    indexedDB.deleteDatabase("alertadis-rindat-api");
    indexedDB.deleteDatabase("alertadis_api");

    authService.logout()
    commit("cleanUserAuthenticated");
    commit("cleanCurrentUser");
  },

  async updatePassword({ commit }, data) {
    const newPassword = data;
    try {
      await UserService.updatePassword(newPassword)
    } catch (error) {
      commit("setCurrentUser", undefined);
      commit("setLoginFailure");
      switch (error.response.status) {
        case 401: // Unauthorized
          throw {
            name: "Dados incorretos",
            message: "O email/matrícula ou a senha não correspondem!",
          }
        case 500: // Unavailable service
          throw {
            name: "Serviço indisponível",
            message: "Não foi possível realizar o login, tente novamente.",
          }
        case 503: // Unavailable service
          throw {
            name: "Serviço indisponível",
            message: "Não foi possível realizar o login, tente novamente.",
          }
      }
    }
  },

  async forgotPassword({ commit }, data) {
    const login = data;
    try {
      await UserService.forgotPassword(login)
    } catch (error) {
      commit("setCurrentUser", undefined);
      commit("setLoginFailure");
      throw error
    }
  },

  async resetPassword({ commit }, data) {
    const login = data;
    try {
      await UserService.resetPassword(login)
    } catch (error) {
      commit("setCurrentUser", undefined);
      commit("setLoginFailure");
      throw error
    }
  },

  async updateInternalPassword(_, data) {
    const login = data;
    await UserService.updateInternalPassword(login)
  },

  async updateUserDetails({ commit }, data) {
    try {
      const department = await departmentService.getDepartmentByIds(data.departmentId);
      let abrv = data.name.split(" ")
      const name = []
      name.push(abrv[0])
      abrv.splice(0, 1)
      abrv.map((e) => {
        if (e.length > 2) {
          name.push(e[0] + ".")
        }
      })
      const userDetails = {
        name: name.join(' '),
        departmentName: department.data.name
      }
      commit("setUserDetails", userDetails);
    } catch (error) {
      console.log(error);
    }
  }
};


const getters = {
  loggedIn: (state) => state.loggedIn && state.token,
  currentUser: (state) => state.currentUser,
  userDetails: (state) => state.userDetails
};

export default {
  state,
  mutations,
  actions,
  getters
}
